<template>
  <router-view></router-view>
</template>

<script>
import wechattype from '../utils/environment'
export default {
  data() {
    return {}
  },
  created() {
    localStorage.setItem('type', wechattype)
  },
  mounted() {
    if (wechattype) {
      if (!localStorage.getItem('openId') && !this.getQueryVariable('code')) {
        //判断是不是微信
        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx31e205b69fed7451&redirect_uri=' +
          // 测试
          // encodeURIComponent(window.location.origin + '/#/login' + this.getHrefQuery()) +

          // vpn
          encodeURIComponent(
            'https://wxhos.asszyy.cn' + '/#/login' + this.getHrefQuery()
          ) +
          '&response_type=code&scope=snsapi_userinfo&state=' +
          this.getStateQuery() +
          '#wechat_redirect'
        return
      }
    } else {
      if (
        !localStorage.getItem('openId') &&
        !this.getQueryVariable('auth_code')
      ) {
        window.location.href =
          'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm' +
          '?app_id=2021002112670557' +
          '&scope=auth_base' +
          '&redirect_uri=' +
          encodeURIComponent(
            'https://wxhos.asszyy.cn' + '/#/login' + this.getHrefQuery()
          ) +
          '&response_type=code' +
          '&state=' +
          this.getStateQuery()
      }
    }
  },
  methods: {
    getQueryVariable(variable) {
      let query = ''
      if (wechattype) {
        // 微信环境
        query = window.location.search.substring(1)
      } else {
        query = window.location.href.split('?')[1]
      }
      let vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] == variable) {
          return true
        }
      }
      return false
    },
    getQueryString(href) {
      let str = href.substring(href.indexOf('?'), href.length)
      debugger
      return str
    },
    getStateQuery() {
      let href = window.location.href
      if (href.indexOf('?') != -1) {
        return href.substring(href.indexOf('#/') + 2, href.indexOf('?'))
      } else {
        return href.substring(href.indexOf('#/') + 2, href.length)
      }
    },
    getHrefQuery() {
      let href = window.location.href
      if (href.indexOf('?') != -1) {
        return href.substring(href.indexOf('?'), href.length)
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped></style>
